var map = {
	"./de/auth.json": 29608,
	"./de/chat.json": 43590,
	"./de/contacts.json": 21407,
	"./de/general.json": 14061,
	"./de/library.json": 89199,
	"./de/settings.json": 57116,
	"./de/support.json": 54401,
	"./de/termsAndConditions.json": 52045,
	"./en/auth.json": 23065,
	"./en/chat.json": 28753,
	"./en/contacts.json": 94761,
	"./en/general.json": 34739,
	"./en/library.json": 80646,
	"./en/settings.json": 46516,
	"./en/support.json": 89837,
	"./en/termsAndConditions.json": 49794,
	"./es/auth.json": 61589,
	"./es/chat.json": 86118,
	"./es/contacts.json": 76196,
	"./es/general.json": 5892,
	"./es/library.json": 51585,
	"./es/settings.json": 98630,
	"./es/support.json": 45515,
	"./es/termsAndConditions.json": 54098,
	"./fr/auth.json": 29599,
	"./fr/chat.json": 80377,
	"./fr/contacts.json": 1322,
	"./fr/general.json": 64888,
	"./fr/library.json": 78856,
	"./fr/settings.json": 53501,
	"./fr/support.json": 92772,
	"./fr/termsAndConditions.json": 60054,
	"./it/auth.json": 89874,
	"./it/chat.json": 96854,
	"./it/contacts.json": 67831,
	"./it/general.json": 58901,
	"./it/library.json": 94891,
	"./it/settings.json": 63547,
	"./it/support.json": 74378,
	"./it/termsAndConditions.json": 24786,
	"./pl/auth.json": 12062,
	"./pl/chat.json": 9166,
	"./pl/contacts.json": 68760,
	"./pl/general.json": 64340,
	"./pl/library.json": 31682,
	"./pl/settings.json": 69820,
	"./pl/support.json": 61988,
	"./pl/termsAndConditions.json": 28757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67195;